import TKModal from "./Modal";

const FounderModal = ({ isOpen, onClose }) => {
  return (
    <TKModal open={isOpen} onClose={onClose} noHeader>
      <div className="flex flex-col gap-4">
        <div>
          <p className="font-bold text-[30px] uppercase">Ife Oyedele</p>
          <p className="text-[18px] text-[#7A7A7A]">Co-Founder</p>
        </div>
        <div>
          <p className="text-[#7A7A7A] text-[18px]">
            Ife Oyedele II is the Co-Founder and Chief Growth Officer at
            Kobo360, Africa’s fastest-growing technology-enabled logistics
            start-up. Oyedele leads growth & expansions, as well as technology
            innovation & product development. He is passionate about incubating
            and developing innovative IT customer solutions. In August 2022, Ife
            co-founded Vine Studio, a venture studio aimed at supporting early
            stage start-ups in building a solid foundation for their businesses
          </p>
        </div>
        <div>
          <p className="text-[#7A7A7A] text-[18px]">
            He has worked in various capacities with several global brands
            including Mercedes Benz, Financial Services and the CFI Group USA
            LLC. In 2016, he combined forces with business partner Obi Ozor to
            launch Kobo360, and together they are building a Global Logistics
            Operating System [G-LOS], a blockchain-enabled platform to power
            trade across the African continent.
          </p>
        </div>
        <div>
          <p className="text-[#7A7A7A] text-[18px]">
            In 2020, Oyedele II alongside his co-founder, Obi Ozor, were
            selected to be a part of Endeavor’s global network of high-impact
            entrepreneurs.
          </p>
        </div>
      </div>
    </TKModal>
  );
};

export default FounderModal;
